import React from 'react';
import { motion } from 'framer-motion';
import { Shield, MapPin, CheckCircle, Clock } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-283">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-284">
        <img src="https://cdn.magicpatterns.com/uploads/n9WnN7tSJs3RykszzTvQTA/Banner_JetForce.png" alt="Commercial aircraft on runway" className="w-full h-full object-cover object-center" data-id="element-285" />
        <div className="absolute inset-0 bg-navy/35 mix-blend-multiply" data-id="element-286"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/30 to-transparent" data-id="element-287"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full flex flex-col items-center text-center mt-10 sm:mt-0" data-id="element-288">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-sm text-slate-200 mb-8" data-id="element-289">
          <span className="w-2 h-2 rounded-full bg-gold animate-pulse mr-2" data-id="element-290"></span>
          Nationwide Coverage · AOG Support · 24/7 Dispatch
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-heading font-bold text-white leading-tight tracking-tight mb-4 uppercase" data-id="element-291">
          We Move What <br className="hidden sm:block" data-id="element-292" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-gold-light" data-id="element-293">
            Keeps You Flying.
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl sm:text-2xl text-gold font-medium mb-6 tracking-wide" data-id="element-294">
          Safe Transport. Secure Handling. Nationwide Coverage.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="max-w-3xl text-base sm:text-lg text-slate-300 mb-10 leading-relaxed" data-id="element-295">
          JetForce Aerospace provides specialized aviation transportation and
          maintenance services for airlines, MROs, repair stations, OEMs and
          operators across the United States.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center gap-4 mb-16 w-full sm:w-auto" data-id="element-296">
          <a href="#contact" className="w-full sm:w-auto bg-gold hover:bg-gold-light text-navy font-bold py-4 px-8 rounded-full transition-all shadow-gold-glow hover:shadow-gold-glow-lg transform hover:-translate-y-1 text-center text-lg" data-id="element-297">
            Request a Quote
          </a>
          <a href="#services" className="w-full sm:w-auto bg-transparent hover:bg-white/10 text-white border-2 border-white font-bold py-3.5 px-8 rounded-full transition-all text-center text-lg backdrop-blur-sm" data-id="element-298">
            Explore Our Services
          </a>
        </motion.div>

        {/* Trust Badges */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8 w-full max-w-4xl border-t border-white/10 pt-8" data-id="element-299">
          {[{
          icon: Shield,
          text: 'Experienced Team'
        }, {
          icon: MapPin,
          text: 'Nationwide Service'
        }, {
          icon: CheckCircle,
          text: 'Fully Insured'
        }, {
          icon: Clock,
          text: 'On Time. Every Time.'
        }].map((badge, idx) => <div key={idx} className="flex flex-col items-center justify-center text-center group" data-id="element-300">
              <div className="w-12 h-12 rounded-full bg-navy-light/80 border border-gold/30 flex items-center justify-center mb-3 group-hover:border-gold transition-colors shadow-lg" data-id="element-301">
                <badge.icon className="w-6 h-6 text-gold" data-id="element-302" />
              </div>
              <span className="text-sm font-medium text-slate-300 font-heading tracking-wider uppercase" data-id="element-303">
                {badge.text}
              </span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}